import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-dialog-header',
	template: `
    <div class="header-container alignRow">
	  <span style="padding-right: auto;" class="alignRow" [ngStyle]="{ 'font-size': headerFontSize }">
			<span class="alignRow"><mat-icon *ngIf="headerIcon">{{headerIcon}}</mat-icon>&nbsp;</span>
			<span>{{headerText}}</span>
	  </span>
      <button #closebutton (click)="onCloseClick.emit()" class="close-button" tabindex="-1">&times;</button>
    </div>
  `,
	styles: [`
		.header-container {
			background-color: var(--default-NAV-Color);
			// color: white;
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 10px;
		}
		.close-button {
			background-color: var(--default-NAV-Color);
			// color: white;
			background: none;
			border: none;
			font-size: 1.5em;
			padding: 0px;
			padding-right: var(--default-padding);
			margin-right:10px;
			cursor: pointer;
			outline: none;
		}

		.close-button:focus {
			outline: none;
		}
  `]
})
export class DialogHeaderComponent {
	@Input() headerIcon: string;
	@Input() headerText: string;
	@Input() headerFontSize: string = '1.5rem'; // default
	@Output() onCloseClick: EventEmitter<void> = new EventEmitter<void>();

	constructor() { }

}
